module.exports = __webpack_public_path__ + "img/no-circle-arrow.eb8548e4.svg";